import React, { useState, useEffect } from 'react'
import dayjs from 'dayjs'
import styles from './style.module.scss'

const Clock = () => {
  const [currentTime, setCurrentTime] = useState(dayjs())

  useEffect(() => {
    // Update waktu setiap detik
    const timer = setInterval(() => {
      setCurrentTime(dayjs())
    }, 1000)

    return () => clearInterval(timer)
  }, [])

  const hours = currentTime.format('HH')
  const minutes = currentTime.format('mm')
  const date = currentTime.format('dddd, D MMM YYYY').toUpperCase()

  return (
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1,
        textAlign: 'center',
        color: '#fff',
      }}
    >
      {/* Jam dengan animasi ticking */}
      <div
        style={{
          fontSize: 72,
          fontWeight: 300,
          lineHeight: 1,
          marginBottom: 8,
          color: '#fff',
          letterSpacing: '-0.02em',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 4,
        }}
      >
        <span>{hours}</span>
        <span
          className={styles.colon}
          style={{
            display: 'inline-block',
            width: '0.2em',
            textAlign: 'center',
          }}
        >
          :
        </span>
        <span>{minutes}</span>
      </div>
      {/* Tanggal */}
      <div
        style={{
          fontSize: 18,
          fontWeight: 400,
          color: 'rgba(255, 255, 255, 0.9)',
          letterSpacing: '0.02em',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        }}
      >
        {date}
      </div>
    </div>
  )
}

export default Clock
